import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import DeleteDocumentModal from '../../external-components/DeleteDocumentModal/DeleteDocumentModal';
import EditDocumentModal from '../../external-components/EditDocumentModal/EditDocumentModal';
import type { EditableDocument } from '../../external-components/EditDocumentModal/useEditDocumentModal';
import { useDocumentMenuAction } from './useDocumentMenuAction';

type Props = {
  document: EditableDocument;
};

export default function DocumentMenuAction(props: Props) {
  const hook = useDocumentMenuAction();

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options de ${props.document.name}`}
        actions={[
          {
            id: 'edit',
            label: 'Modifier',
            icon: <EditIcon fontSize="small" />,
            onClick: hook.handleOpenEditModal,
          },
          {
            id: 'delete',
            label: 'Supprimer',
            icon: <DeleteIcon fontSize="small" />,
            onClick: hook.handleOpenDeleteModal,
          },
        ]}
      />

      {hook.isEditModalOpen ? (
        <EditDocumentModal document={props.document} onClose={hook.handleCloseEditModal} />
      ) : null}

      {hook.isDeleteModalOpen ? (
        <DeleteDocumentModal document={props.document} onClose={hook.handleCloseDeleteModal} />
      ) : null}
    </>
  );
}
